import { defineComponent, openBlock, createElementBlock, createVNode, unref, createElementVNode, createTextVNode, withCtx, toDisplayString, createCommentVNode, Fragment, renderList } from "vue";
import { IconCheckLg, CdrLink, IconXFill, CdrButton } from "@rei/cedar";
const _hoisted_1 = {
  key: 0,
  id: "wishlist-modal-success",
  class: "success-message"
};
const _hoisted_2 = {
  class: "success-message__text"
};
const _hoisted_3 = {
  key: 0,
  class: "success-message__additional"
};
const _hoisted_4 = {
  key: 1,
  id: "wishlist-modal-all-wishlists"
};
const _hoisted_5 = {
  class: "all-wishlists"
};
const _hoisted_6 = {
  key: 2,
  id: "wishlist-modal-error",
  class: "error-message"
};
const _hoisted_7 = {
  key: 3,
  class: "no-wishlists"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AddToWishlistModal",
  props: {
    allWishlists: {
      default: () => []
    },
    wishlistUrl: {
      default: ""
    },
    errorMessage: {
      default: ""
    },
    selectedWishlist: {
      default: () => ({
        link: "",
        name: "",
        id: ""
      })
    },
    showError: {
      type: Boolean,
      default: false
    },
    showLists: {
      type: Boolean,
      default: false
    },
    showSuccess: {
      type: Boolean,
      default: false
    }
  },
  emits: ["wishlistSelect"],
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", null, [_ctx.showSuccess ? (openBlock(), createElementBlock("div", _hoisted_1, [createVNode(unref(IconCheckLg), {
        class: "success-message__check"
      }), createElementVNode("div", _hoisted_2, [_cache[2] || (_cache[2] = createTextVNode(" This item has been added to: ")), createVNode(unref(CdrLink), {
        href: _ctx.selectedWishlist.link,
        modifier: "standalone"
      }, {
        default: withCtx(() => [createTextVNode(toDisplayString(_ctx.selectedWishlist.name), 1)]),
        _: 1
      }, 8, ["href"]), _ctx.allWishlists.length > 1 ? (openBlock(), createElementBlock("div", _hoisted_3, [createVNode(unref(CdrLink), {
        type: "button",
        modifier: "standalone",
        onClick: _cache[0] || (_cache[0] = ($event) => _ctx.$emit("wishlistSelect"))
      }, {
        default: withCtx(() => _cache[1] || (_cache[1] = [createTextVNode(" Add item to another wish list ")])),
        _: 1,
        __: [1]
      })])) : createCommentVNode("", true)])])) : createCommentVNode("", true), _ctx.showLists ? (openBlock(), createElementBlock("div", _hoisted_4, [createElementVNode("ul", _hoisted_5, [(openBlock(true), createElementBlock(Fragment, null, renderList(_ctx.allWishlists, (list) => {
        return openBlock(), createElementBlock("li", {
          key: list.id
        }, [createVNode(unref(CdrLink), {
          type: "button",
          modifier: "standalone",
          onClick: ($event) => _ctx.$emit("wishlistSelect", {
            list
          })
        }, {
          default: withCtx(() => [createTextVNode(toDisplayString(list.name), 1)]),
          _: 2
        }, 1032, ["onClick"])]);
      }), 128))])])) : createCommentVNode("", true), _ctx.showError ? (openBlock(), createElementBlock("div", _hoisted_6, [createVNode(unref(IconXFill), {
        class: "error-message__x-fill"
      }), createTextVNode(" " + toDisplayString(_ctx.errorMessage), 1)])) : createCommentVNode("", true), _ctx.allWishlists.length === 0 ? (openBlock(), createElementBlock("div", _hoisted_7, [_cache[4] || (_cache[4] = createElementVNode("p", null, " Due to a technical issue, we are unable to create a new wish list from this page. Please navigate to the wish lists and registries page, sign in and create a new wish list. Once you have created a new wish list, come back and add this product. ", -1)), createVNode(unref(CdrButton), {
        tag: "a",
        "full-width": "@xs",
        href: _ctx.wishlistUrl,
        "data-ui": "wishlist-link"
      }, {
        default: withCtx(() => _cache[3] || (_cache[3] = [createTextVNode(" Wish lists and registries page ")])),
        _: 1,
        __: [3]
      }, 8, ["href"])])) : createCommentVNode("", true)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AddToWishlistModal.mjs.map
